import moment from 'moment';

class dateFormatService {
    formatDate(dateString) {
        return moment(dateString).format('DD/MM/YYYY');
    }
    formatDateTime(dateString) {
        return moment(dateString).format('DD/MM/YYYY HH:mm:ss');
    }
    formatDatePeriod(dateString) {
        return moment(dateString).format('DD MMM YYYY');
    }
    formatMysSqlDate(dateString) {
        return moment(dateString).format('YYYY-MM-DD');

    }
    formatDateWithMonthName(dateString) {
        return moment(dateString).format('DD MMM YYYY');
    }
    diffDateDays(dateStringFrom, dateStringTo){
        return moment(dateStringTo).diff(moment(dateStringFrom), 'days');
        // return moment([2007, 0, 29]);
    }

}
  
export default new dateFormatService();
